(function () {
    'use strict';

    angular
        .module('pdgWp')
        .config(reportsConfig);

    /** @ngInject */
    function reportsConfig($stateProvider) {

        var reports = {
            name : 'reports',
            url  : '/reports',
            resolve: {
                itemsList  : function (itemsSrv) {

                    var configObj = {
                        search   : true,
                        expandGid: true,
                        prices   : true,
                        gpModOdr : 'DESC',
                        getPaging: true,
                        limit    : "10",
                        page     : "1"

                    };

                    return itemsSrv.getItems(configObj)
                                   .then(function (itemsList) {
                                       return itemsList.data;
                                   });
                },
                itemDetails: function () {
                    return {};
                }
            },
            views: {
                'sideNavRight@': {
                    templateUrl : '/ng-app/admin-app/website-admin/items/items-list.partial.html',
                    controller  : 'ItemsListController',
                    controllerAs: 'itemsListCtrl'
                },
                'main@': {
                    templateUrl : '/ng-app/admin-app/website-admin/reports/reports.partial.html',
                    controller  : 'ReportsController',
                    controllerAs: 'reportsCtrl'
                }
            }
        };

        $stateProvider.state(reports);
    }
})();
